<template>
  <div>
    <v-row class="grey darken-4 mx-0 rounded">
      <v-col cols="6" md="4" sm="3" class="align-self-center">
        <v-text-field
          persistent-hint
          class="text-caption"
          :label="$t('labels.termoBusca')"
          :placeholder="$t('labels.marca')"
          dense
          dark
          outlined
          v-model="searchFields.text"
          :maxlength="searchFields.maxLength"
        />
      </v-col>
    </v-row>
    <index-buttons
      @search="sendSearch()"
      @register="openRegister()"
      @changeHeader="changeHeaderDialog = !changeHeaderDialog"
    />
    <v-row>
      <v-col cols="12">
        <megabit-table
          :table-header="tableHeaderSelected"
          :table-items="brandList"
          :loading="loadingItems"
          selectable
          :doDelete="doDelete"
          @item-selected="selectItem($event)"
          route="marca.register"
          chave="NOME"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="d-inline-flex">
        <v-pagination
          class="ml-auto"
          v-model="pagination.current_page"
          :total-visible="pagination.per_page"
          :length="pagination.last_page"
          :disabled="loadingItems"
          @input="changePage($event)"
        />
      </v-col>
    </v-row>
    <router-view />
    <change-header
      v-model="tableHeaderAvaiable"
      :showDialog="changeHeaderDialog"
      @close="changeHeaderDialog = !changeHeaderDialog"
      :name="headerName"
    />
  </div>
</template>

<script>
import { brandMixin } from '@/mixins/object/brand/BrandMixin'
import { tableMixin } from '@/mixins/component/table/TableMixin'
import { headerMixin } from '@/mixins/component/table/HeaderMixin'
import MegabitTable from '@/components/shared/table/MegabitTable'
import { mapState, mapActions } from 'vuex'
import IndexButtons from '@/components/shared/base-buttons/IndexButtons'
export default {
  components: { MegabitTable, IndexButtons },
  mixins: [brandMixin, tableMixin, headerMixin],
  data: () => {
    return {
      headerName: 'brandIndex',
      query: { page: 1, nome: '' },
      searchFields: {
        text: '',
        maxLength: 12,
      },
      tableHeaderAvaiable: [
        {
          label: 'nome',
          text: 'Nome',
          value: 'NOME',
          align: 'left',
          show: true,
        },
        {
          label: 'acoes',
          text: 'Ações',
          value: 'controls',
          align: 'right',
          show: true,
        },
      ],
    }
  },
  computed: {
    ...mapState('brandModule', ['brandList', 'loadingItems', 'pagination']),
  },
  mounted() {
    this.fetch()
    this.mountHeader()
  },
  methods: {
    ...mapActions({
      getBrand: 'brandModule/getBrand',
      deleteBrand: 'brandModule/deleteBrand',
    }),
    async sendSearch(type = 'search') {
      try {
        if (type == 'search') this.query.page = 1
        this.query.nome = this.searchFields.text
        await this.getBrandsAPI(this.query)
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
    },
    changePage(page) {
      if (page) this.query.page = page
      else this.query.page = this.groupPagination.currentPage
      this.sendSearch('changePage')
    },
    async doDelete(item) {
      try {
        const response = await this.deleteBrand(item.NOME)
        this.$toasted.success(response)
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
    },

    openRegister() {
      this.$router.push({ name: 'marca.register' })
    },

    async findBrand() {
      try {
        if (this.selectedItem) {
          await this.getBrand(this.selectedItem)
        }
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
    },

    async fetch() {
      try {
        await this.getBrandsAPI(this.query)
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
    },
  },
}
</script>

<style></style>
